import { BORDER_GRAY_COLOR } from "../../../utils/colors";
import { HEIGHT_BUTTON } from "../../../utils/constants";

export const MODAL_COMPETITORS_FROM_MENU = "menu";
export const MODAL_COMPETITORS_FROM_CREATE_WITH_IA = "createWithIA";

export const MOVE_MODAL_PURPOSE_SELECTION = "selection";
export const MOVE_MODAL_PURPOSE_FAVORITE_DESTINATION = "favoriteDestination";

export const COMPETITOR_FILTER_ADD_VALUE = "__add_competitor__";

export const COMPETITORS_COMPETITOR_FILTER_FIELD =
  "competitorAdsCompetitorFilter";
export const COMPETITORS_PLATFORM_FILTER_FIELD = "platform";

export const COMPETITORS_LOADING_TIME_MS = 60 * 1000;
export const COMPETITORS_CACHED_LOADING_MIN_MS = 2 * 1000;
export const COMPETITORS_LOADER_TICK_MS = 100;
export const COMPETITORS_LOADER_MAX_PROGRESS_UNTIL_READY = 92;
export const COMPETITORS_LOADER_COMPLETE_STEP = 2;
export const COMPETITORS_LOADER_FINISH_DELAY_MS = 400;
export const COMPETITORS_LOADER_EASE_EXPONENT = 2.5;

export const MODAL_COMPETITORS_CONTENT_PADDINGS = {
  pl: { xs: 1.5, sm: 5 },
  pr: { xs: 2.5, sm: 6 },
};

export const MODAL_COMPETITORS_GALLERY_PADDINGS = {
  pl: MODAL_COMPETITORS_CONTENT_PADDINGS.pl,
  pr: { xs: 1.5, sm: 3 },
};

export const MODAL_COMPETITORS_HEADER_ROW_SX = {
  flexShrink: 0,
  display: "flex",
  gap: 1.5,
  alignItems: "center",
  justifyContent: "space-between",
  pr: MODAL_COMPETITORS_CONTENT_PADDINGS.pr,
  pl: MODAL_COMPETITORS_CONTENT_PADDINGS.pl,
  height: 84,
  bgcolor: "background.paper",
};

export const MODAL_COMPETITORS_TITLE_SX = {
  fontSize: {
    xs: 22,
    sm: 30,
  },
};

export const MODAL_COMPETITORS_TOOLBAR_ROW_SX = {
  display: "flex",
  alignItems: "center",
  width: "100%",
  boxSizing: "border-box",
  py: 2,
  pr: MODAL_COMPETITORS_CONTENT_PADDINGS.pr,
  pl: MODAL_COMPETITORS_CONTENT_PADDINGS.pl,
  backgroundColor: "common.white",
  borderBottom: `1px solid ${BORDER_GRAY_COLOR}`,
  flexShrink: 0,
};

export const MODAL_COMPETITORS_FOLDER_TOOLBAR_ROW_SX = {
  ...MODAL_COMPETITORS_TOOLBAR_ROW_SX,
  alignItems: "flex-start",
  flexDirection: "column",
  gap: 1,
  py: 1,
};

export const MODAL_COMPETITORS_BODY_SX = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  borderTop: `1px solid ${BORDER_GRAY_COLOR}`,
};

export const MODAL_COMPETITORS_SCROLL_AREA_SX = {
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
};

export const COMPETITOR_FILTER_BAR_SX = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flexWrap: "wrap",
  width: "auto",
  maxWidth: "100%",
};

export const COMPETITOR_FILTER_SELECT_WRAPPER_SX = {
  flex: "0 0 auto",
  width: 280,
  minWidth: 240,
  maxWidth: 320,
};

export const COMPETITOR_PLATFORM_FILTER_SELECT_WRAPPER_SX = {
  flex: "0 0 auto",
  width: 220,
  minWidth: 220,
  maxWidth: 220,
};

export const COMPETITOR_FILTER_SELECT_SX = {
  width: "100%",
  maxWidth: "100%",
  height: HEIGHT_BUTTON,
  minWidth: 0,
  "& .MuiFilledInput-root": {
    height: HEIGHT_BUTTON,
    minHeight: HEIGHT_BUTTON,
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    minHeight: "unset",
    py: 0,
    height: HEIGHT_BUTTON,
  },
};

export const MODAL_COMPETITORS_FOOTER_LOADER_SX = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#FFF",
  flexShrink: 0,
  borderTop: `1px solid ${BORDER_GRAY_COLOR}`,
  py: 1.5,
  pl: MODAL_COMPETITORS_CONTENT_PADDINGS.pl,
  pr: MODAL_COMPETITORS_CONTENT_PADDINGS.pr,
  width: "100%",
  maxWidth: "none",
  boxSizing: "border-box",
  "& > :first-of-type": {
    width: "100%",
    maxWidth: "none",
  },
};
